<div class="content__inner">
    <header class="content__title">
        <h1>{{ 'pointsofinterest.list.title' | translate }}</h1>
        <small>{{ 'pointsofinterest.list.subtitle' | translate }}</small>

        <div class="actions"> 
            <button *appHasPermission="'POINTSOFINTEREST.ADD'" (click)="add()" class="btn btn-success btn--icon-text"><i class="zmdi zmdi-collection-plus"></i> {{ 'pointsofinterest.list.add' | translate }}</button>
        </div>
    </header>

    <div class="card" *appHasPermission="'POINTSOFINTEREST.LIST'">
        <div class="card-body">
            <h4 class="card-title">{{ 'pointsofinterest.list.card.title' | translate }}</h4>

            <table datatable class="table table-bordered" [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
                <thead>
                    <tr>
                        <th scope="col">{{ 'pointsofinterest.props.name' | translate }}</th>
                        <th scope="col">{{ 'pointsofinterest.props.postalcode' | translate }}</th>
                        <th scope="col">{{ 'pointsofinterest.props.city' | translate }}</th>
                        <th scope="col">{{ 'pointsofinterest.props.country' | translate }}</th>
                        <th scope="col">{{ 'pointsofinterest.props.created' | translate }}</th>
                        <th scope="col">{{ 'pointsofinterest.props.updated' | translate }}</th>
                        <th scope="col"></th>
                    </tr>
                </thead>
                <tbody *ngIf="rows?.length != 0">
                    <tr *ngFor="let row of rows">
                        <td>{{ row.name }}</td>
                        <td>{{ row.postalcode }}</td>
                        <td>{{ row.city }}</td>
                        <td>{{ row.country }}</td>
                        <td>{{ row.created | date:UTCDATEFORMAT:'+0' }}</td>
                        <td>{{ row.updated | date:UTCDATEFORMAT:'+0' }}</td>
                        <td class="text-right nowrap">
                            <i (click)="edit(row._id)" class="zmdi zmdi-edit zmdi-hc-fw tableIcon" *appHasPermission="'POINTSOFINTEREST.EDIT'"></i>
                            <i (click)="delete(row._id)" class="zmdi zmdi-delete zmdi-hc-fw tableIcon" *appHasPermission="'POINTSOFINTEREST.DELETE'"></i>
                        </td>
                    </tr>
                </tbody>
                <tbody *ngIf="rows?.length == 0">
                    <tr>
                        <td colspan="7" class="no-data-available">{{ 'global.datatable.empty' | translate }}</td>
                    </tr>
                <tbody>
            </table>
        </div>
    </div>
</div>